<template>
    <el-dialog
        top="5vh"
        :visible="visible"
        :title="fileName"
        :center="true"
        :lock-scroll="true"
        :show-close="false"
        custom-class="pdf-dialog"
    >
        <script-import :src="`${publicPath}js/pdf/pdf.js`"></script-import>
        <script-import :src="`${publicPath}js/pdf/pdf.worker.js`"></script-import>
        <div class="popup-main">
            <div id="pdf-container-parent" class="bg-content">
                <div v-if="pdfContainerShow" id="pdf-container"></div>
                <div class="enter-bottom">
                    <button
                        class="agree-btn fc-title-default bg-btn-use fs-xl"
                        :style="{ backgroundColor: bgColor }"
                        :disabled="showTime"
                        v-on:click="handleOk"
                    >
                        {{ tipText }}
                        <span v-if="showTime">({{ timeCount }}s)</span>
                    </button>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import conf from "@/config/index";
import ScriptImport from "@/components/util/scriptImport";
import fundApi from "@/api/fund";
export default {
    name: "PdfPopup",
    components: { ScriptImport },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        readFileInfoList: {
            type: Array,
            default: () => []
        },
        needTime: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            tipText: "我已阅读并知悉以上协议",
            timeCount: 15,
            pdfNums: 0,
            pdfRenderPromise: null,
            pdfContainerShow: true,
            fileName: "",
            timer: "",
            bgColor: "red",
            isShow: false,
            isBase64: false,
            publicPath: process.env.BASE_URL
        };
    },
    computed: {
        showTime: function () {
            return this.needTime && this.timeCount !== 0;
        }
    },
    watch: {
        visible: function (val) {
            if (val) {
                if (this.readFileInfoList.length === 1) {
                    this.fileName = this.readFileInfoList[0].filename;
                } else {
                    this.fileName = "信披文件";
                }
                if (this.needTime) {
                    this.timeCount = this.$cache.getCompanyInfoParam("10102011");
                    this.tipText = "请阅读并知悉以上协议";
                    let _this = this;
                    _this.bgColor = "#dfdfdf";
                    let timeInterval = setInterval(function () {
                        if (_this.timeCount <= 1) {
                            _this.bgColor = "red";
                            _this.tipText = "我已阅读并知悉以上协议";
                            _this.timeCount = 0;
                            clearInterval(timeInterval);
                        } else {
                            _this.timeCount = _this.timeCount - 1;
                        }
                    }, 1000);
                }
                this.pdfNums = 0;
                this.pdfRenderPromise = null;
                this.pdfContainerShow = true;
                this.initPdfCanvas();
            }
        }
    },
    mounted: function () {
        let flag = this.$vnode.data.attrs["base64"];
        this.isBase64 = flag === "" || flag === "true"; // 父组件有base64属性
    },
    methods: {
        handleOk: function () {
            this.removePdfCanvas();
            this.$emit("close");
        },
        removePdfCanvas: function () {
            let el = document.getElementById("pdf-container");
            let childs = el.childNodes;
            for (let i = childs.length - 1; i >= 0; i--) {
                el.removeChild(childs[i]);
            }
            this.pdfContainerShow = false;
        },
        showPdf: function () {
            let _this = this;
            this.pdfRenderPromise = new Promise(function (resolve, reject) {
                window.PDFJS.getDocument(_this.getPath(_this.readFileInfoList[_this.pdfNums])).then(
                    function (pdf) {
                        _this.renderPageAsync(pdf, 1, resolve);
                    }
                );
            });
            return this.pdfRenderPromise;
        },
        initPdfCanvas: function () {
            let _this = this;
            if (this.isBase64) {
                this.getPdfBase64(_this.readFileInfoList[this.pdfNums]).then((res) => {
                    _this.showPdf().then(function (res) {
                        if (_this.pdfNums < _this.readFileInfoList.length) {
                            _this.initPdfCanvas();
                        }
                    });
                });
            }
        },
        renderPageAsync: function (pdf, pageNum, resolve) {
            let container = document.getElementById("pdf-container");
            if (container) {
                let _this = this;
                if (pageNum <= pdf.numPages) {
                    pdf.getPage(pageNum).then(function (pages) {
                        let scale = 1.5;
                        let viewport = pages.getViewport(scale);
                        let canvas = document.createElement("canvas");
                        let context = canvas.getContext("2d");
                        container.appendChild(canvas);
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        // canvas.style.width = "85vw";
                        // canvas.style.margin = "-60px";
                        let renderContext = {
                            canvasContext: context,
                            viewport: viewport
                        };
                        pages.render(renderContext).then(function () {
                            _this.renderPageAsync(pdf, pageNum + 1, resolve);
                        });
                    });
                } else {
                    this.pdfNums += 1;
                    resolve();
                }
            }
        },
        getPdfBase64(item) {
            let params = {
                fileCode: item.fileid
            };
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async (resolve, reject) => {
                const res = await fundApi.getPdfBase64(params);
                if (res.data) {
                    item.pdfBase64 = res.data;
                    resolve();
                }
            });
        },
        convertDataToBinary(base64Data) {
            let raw = window.atob(base64Data);
            let rawLength = raw.length;
            let array = new Uint8Array(new ArrayBuffer(rawLength));
            for (let i = 0; i < rawLength; i++) {
                array[i] = raw.charCodeAt(i);
            }
            return array;
        },
        getPath: function (item) {
            if (this.isBase64) {
                return this.convertDataToBinary(item.pdfBase64);
            }
            let origin = window.document.location.origin;
            // 请求nginx静态资源路径
            return origin + "/agate/api/v1/static" + item.textaddress;
        }
    }
};
</script>

<style lang="scss">
.popup-main {
    width: 95%;
    height: 100%;
    position: relative;
    margin: 0 auto;
    overflow: hidden;
}

.bg-content {
    background: #ffffff;
}

.fc-title-default {
    color: #ffffff;
}

.enter-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.agree-btn {
    width: 100%;
    display: block;
    height: 42px;
    border: none;
    outline: none;
    margin: 0;
}

.bg-btn-use {
    background: #ff5456;
}

.fs-xl {
    font-size: 1.46rem;
}

.el-dialog {
    position: relative;
    background: #ffffff;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 80%;
}

.el-dialog__body {
    background-color: #ffffff;
    max-height: 85% !important;
    min-height: 70%;
    overflow-y: auto;
}
.pdf-dialog {
    height: 90%;
    .el-dialog__body {
        border-top: 1px solid #dcdfe6;
        border-bottom: 1px solid #dcdfe6;
    }
}
</style>
